import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  firmwareWrapper: {
    borderTop: '1px solid rgba(0, 0, 0, 0.4)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    margin: '20px 0',
    padding: '30px 20px',
  },
  selectWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  firmwareButton: {
    width: '80%',
    backgroundColor: '#3f51b5',
    color: '#fff',
    borderRadius: 4,
    alignItems: 'center',
    '& .Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
  updateFirmware: {
    fontSize: '0.875rem',
    letterSpacing: '0.02857em',
  },
  firmwareButtonSummary: {
    '& .MuiAccordionSummary-content': {
      margin: 0,
    },
    minHeight: '40px !important',
  },
  progressWrapper: {
    width: '100%',
    height: 50,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  firmwaresTip: {
    color: '#000',
    fontSize: 13,
    width: 150,
  },
  expandIcon: {
    fontSize: '14px',
    color: '#fff',
  },
  firmwareDetails: {
    padding: 4,
    backgroundColor: '#CCCCCC',
  },
  firmwareList: {
    width: '100%',
    color: '#000',
    fontSize: 14,
  },
  firmwareVersion: {
    width: '100%',
    fontSize: '12px',
    cursor: 'pointer',
    transition: '0.15s all ease-in',
    '&:hover': {
      opacity: 0.7,
      background: '#fff',
      color: '#000',
    },
  },
  '@media (max-width: 860px)': {
    startAndProgressWrapper: {
      border: 'none',
    },
    firmwareTitle: {
      width: '100%',
      textAlign: 'center',
      marginBottom: 10,
    },
    firmwareButton: {
      width: '100%',
    },
    selectWrapper: {
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: 20,
    },
  },
  '@media (max-width: 420px)': {
    firmwareTitle: {
      fontSize: 14,
    },
    updateFirmwareButton: {
      margin: '0 15px 0 0',
    },
  },
}))

export default useStyles
